export default {
    root: {
        padding: 15,
        "&:last-child": {
            paddingBottom: 15,
        },
    },
};
